import type { LifeInsuranceTariffBase } from "./types";

export const formatLifeInsuranceTariff = (tariff?: LifeInsuranceTariffBase): string | undefined =>
  tariff ? `${tariff.code} - ${tariff.name}` : undefined;
